// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.neighbours-view-menu[data-v-817c23ce] {
  list-style-type: none;
  margin: 0;
  padding: 0;
  clear: both;
  height: 3rem;
}
.neighbours-view-menu li[data-v-817c23ce] {
  display: block;
  width: 3rem;
  float: left;
  margin-left: 1rem;
}
.neighbours-search[data-v-817c23ce] {
  /*display: none;*/
  margin-top: 0;
  margin-bottom: 0.4rem;
}
.neighbours-search input[data-v-817c23ce] {
  width: 90%;
  border-width: 0;
  border-bottom: 1px solid #727070;
  height: 1.6em;
  line-height: 2rem;
}
.neighbours-view ul[data-v-817c23ce] {
  position: relative;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.neighbours-view li a.trigger-click[data-v-817c23ce] {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/renderers/neighbours-view-renderer/neighbours-view.vue"],"names":[],"mappings":"AACA;EACC,qBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAAD;AAEC;EACC,cAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;AAAF;AAIA;EACC,iBAAA;EACA,aAAA;EACA,qBAAA;AADD;AAGC;EACC,UAAA;EACA,eAAA;EACA,gCAAA;EACA,aAAA;EACA,iBAAA;AADF;AAMC;EACC,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AAHF;AAMC;EACC,eAAA;AAJF","sourcesContent":["\n.neighbours-view-menu {\n\tlist-style-type: none;\n\tmargin: 0;\n\tpadding: 0;\n\tclear: both;\n\theight: 3rem;\n\n\tli {\n\t\tdisplay: block;\n\t\twidth: 3rem;\n\t\tfloat: left;\n\t\tmargin-left: 1rem;\n\t}\n}\n\n.neighbours-search {\n\t/*display: none;*/\n\tmargin-top: 0;\n\tmargin-bottom: 0.4rem;\n\n\tinput {\n\t\twidth: 90%;\n\t\tborder-width: 0;\n\t\tborder-bottom: 1px solid #727070;\n\t\theight: 1.6em;\n\t\tline-height: 2rem;\n\t}\n}\n\n.neighbours-view {\n\tul {\n\t\tposition: relative;\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n\n\tli a.trigger-click {\n\t\tcursor: pointer;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
